import React from 'react';
import { CheckCircleIcon, StarIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-navy-dark overflow-hidden pt-8 pb-12 md:pt-16 md:pb-24 lg:pt-24 lg:pb-32" data-id="element-58">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-hero-glow opacity-60 pointer-events-none" data-id="element-59" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center" data-id="element-61">
          {/* Left Column: Copy */}
          <div className="flex flex-col items-start text-left" data-id="element-62">
            <div className="inline-flex items-center gap-2 bg-navy-light/50 border border-gold/30 rounded-full px-3 py-1 mb-4 backdrop-blur-sm" data-id="element-63">
              <ShieldCheckIcon className="w-3 h-3 text-gold flex-shrink-0" data-id="element-64" />
              <span className="text-gold text-xs font-bold tracking-wide uppercase leading-tight" data-id="element-65">
                Método 100% Legal · Ley FCRA
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4" data-id="element-66">
              ¿Cansada de pagar el{' '}
              <span className="text-gold-gradient italic block sm:inline" data-id="element-67">
                "Impuesto por ser Latina"?
              </span>
            </h1>

            <p className="font-body text-base sm:text-lg text-gray-300 mb-5 leading-relaxed max-w-xl" data-id="element-68">
              El 79% de los reportes de crédito en USA tienen errores que
              <strong className="text-white" data-id="element-69">
                {' '}
                TE ESTÁN COSTANDO DINERO CADA MES
              </strong>
              . Deja de ser invisible para los bancos.
            </p>

            <div className="flex flex-col gap-3 w-full sm:w-auto mb-5" data-id="element-70">
              <button onClick={scrollToPricing} className="bg-gold hover:bg-gold-light text-navy-dark font-bold text-base sm:text-lg py-3.5 px-6 rounded-lg shadow-[0_0_20px_rgba(201,168,76,0.4)] transition-all duration-300 transform hover:scale-105 text-center" data-id="element-71">
                SÍ, QUIERO ARREGLAR MI CRÉDITO
              </button>
              <p className="text-gray-400 text-xs flex items-center justify-center sm:justify-start" data-id="element-72">
                <span className="mr-2" data-id="element-73">🔒</span> Pago único y seguro · Acceso
                inmediato
              </p>
            </div>

            <div className="flex items-center gap-3 text-sm text-gray-300" data-id="element-74">
              <div className="flex -space-x-2" data-id="element-75">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-7 h-7 rounded-full bg-gray-600 border-2 border-navy-dark flex items-center justify-center text-xs overflow-hidden" data-id="element-76">
                    <img src={`https://randomuser.me/api/portraits/women/${40 + i}.jpg`} alt="User" className="w-full h-full object-cover" data-id="element-77" />
                  </div>)}
              </div>
              <div className="flex flex-col" data-id="element-78">
                <div className="flex text-gold" data-id="element-79">
                  {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" data-id="element-80" />)}
                </div>
                <span className="text-xs" data-id="element-81">+1,200 latinas ayudadas</span>
              </div>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="relative mx-auto lg:mr-0 w-full max-w-sm sm:max-w-md lg:max-w-full" data-id="element-82">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gold/20 bg-navy/50 backdrop-blur-sm p-2 sm:p-4" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/rrdQ5E7ufrpJvzL5tyeFzV/imagen_4_credito_7502B.png" alt="Mujer latina revisando su crédito exitosamente" className="w-full h-auto rounded-lg shadow-lg" data-id="element-84" />

              {/* Floating Badge */}
              <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-white p-3 rounded-lg shadow-xl border-l-4 border-gold max-w-[180px] hidden sm:block" data-id="element-85">
                <div className="flex items-center gap-2 mb-1" data-id="element-86">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-87" />
                  <span className="font-bold text-navy text-xs" data-id="element-88">Aprobada</span>
                </div>
                <p className="text-xs text-gray-600" data-id="element-89">
                  "¡Mi score subió 120 puntos en 45 días!"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}